module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideList),
      expression: "hideList"
    }],
    staticClass: "z-color-select",
    class: {
      'focused': _vm.showColors,
      'has-error': (_vm.error && _vm.error.length),
    }
  }, [_c('div', {
    staticClass: "z-color-select-container",
    class: {
      'focused': _vm.showColors
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$props.label) + " ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "preview",
    on: {
      "click": _vm.toggleColors
    }
  }, [(_vm.colorValue) ? _c('div', {
    staticClass: "value active-icon",
    style: ('background-color: ' + _vm.colorValue)
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.colorLabel ? _vm.colorLabel[_vm.listLabel] : _vm.$props.placeholder))]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showColors),
      expression: "showColors"
    }],
    staticClass: "colors-container"
  }, [_c('div', {
    staticClass: "colors"
  }, _vm._l((_vm.$props.colors), function(color, i) {
    return _c('div', {
      key: ("simple-color-input-" + _vm.uid + "-" + i),
      staticClass: "color"
    }, [_c('label', {
      class: {
        'color__label': true,
        'active': _vm.colorValue == color[_vm.listValue],
      },
      attrs: {
        "for": ("simple-color-input-" + _vm.uid + "-" + i)
      }
    }, [_c('i', {
      staticClass: "color__value",
      style: ('background-color: ' + color[_vm.listValue] + ';')
    }), _vm._v("\n                    " + _vm._s(color[_vm.listLabel]) + "\n                ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.colorValue),
        expression: "colorValue"
      }],
      attrs: {
        "id": ("simple-color-input-" + _vm.uid + "-" + i),
        "type": "radio",
        "name": _vm.$props.name
      },
      domProps: {
        "value": color[_vm.listValue],
        "checked": _vm._q(_vm.colorValue, color[_vm.listValue])
      },
      on: {
        "click": _vm.toggleColors,
        "change": function($event) {
          _vm.colorValue = color[_vm.listValue]
        }
      }
    })])
  }))]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dca77a6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZColorSelector.vue
// module id = 1264
// module chunks = 0